export default "__VITE_ASSET__C9IY0rQm__"